<template>
  <Popover placement="bottom" width="200" trigger="hover">
    <Form ref="form" :model="formData">
      <FormItem label="大于">
        <InputNumber style="width: 80%" size="small" v-model="formData.min" />
      </FormItem>
      <FormItem label="小于">
        <InputNumber style="width: 80%" size="small" v-model="formData.max" />
      </FormItem>
      <FormItem>
        <div class="button">
          <Button size="small" type="primary" @click="confirm">确定</Button>
          <Button size="small" @click="reset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <span slot="reference">
      <img class="icon" :src="filterIcon" />
    </span>
  </Popover>
</template>

<script>
import { Popover, Form, FormItem, InputNumber, Button } from 'element-ui';

import filterIcon from '@/assets/image/icon/filter-icon.png';

export default {
  components: {
    Popover,
    Form,
    FormItem,
    InputNumber,
    Button
  },

  props: {
    // 字段类型
    type: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      formData: {
        min: undefined,
        max: undefined
      },

      filterIcon
    };
  },

  methods: {
    confirm() {
      const { min, max } = this.formData;
      const filterStr = {};
      if (min) filterStr.min = `${this.type}:${min}`;
      if (max) filterStr.max = `${this.type}:${max}`;
      this.$emit('confirm', {
        data: this.formData,
        str: filterStr,
        type: this.type
      });
    },

    reset() {
      this.formData = {
        min: undefined,
        max: undefined
      };
      this.$emit('reset', this.type);
    }
  }
};
</script>

<style lang="less" scoped>
.icon {
  width: 10px;
}

.button {
  display: flex;
  justify-content: center;
}
</style>
